class RecentlyViewed extends customElements.get('products-carousel') {
  constructor() {
    super();

    this.productHandle = this.dataset.productHandle;
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      this.fetchRecentProducts();
    }

    new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 1000px 0px'}).observe(this);
  }

  fetchRecentProducts() {
    const handles = localStorage.getItem('recently-viewed');

    if (!handles) {
      this.classList.add('hidden');
      return;
    }

    const handlesToFetch = Array.from(new Set(handles.split(',')))
      .filter(handle => handle && handle !== this.productHandle)
      .slice(0, 4);

    if (handlesToFetch.length === 0) {
      this.classList.add('hidden');
      return;
    }

    const fetchProductsByHandle = handlesToFetch.map(handle =>
      fetch(`${window.Shopify.routes.root}products/${handle}?view=card`)
        .then(response => response.ok ? response.text() : '')
        .catch(() => '')
    );

    Promise.all(fetchProductsByHandle)
      .then(responses => {
        const list = this.querySelector('.splide__list');

        responses.forEach(html => {
          if (!html) return;
          const product = new DOMParser().parseFromString(html, 'text/html').querySelector('product-card');
          if (!product) return;
          const productHtmlWrapper = document.createElement('DIV');

          productHtmlWrapper.classList.add('products-carousel__slide', 'splide__slide');
          productHtmlWrapper.appendChild(product);
          list.append(productHtmlWrapper);
        });

        if (!list.children.length) {
          this.classList.add('hidden');
          return;
        }

        this.initSlider();
        this.toggleSliderHandler();
        window.addEventListener('resize', debounce(this.toggleSliderHandler.bind(this), 500));
      })
  }
}

customElements.define('recently-viewed', RecentlyViewed);
